import styled from 'styled-components';
import {faArrowLeft} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useStore} from '@/store/root-store';
import {observer} from 'mobx-react';
import {urlValidationRegex2} from '@/constants/regex';
import moment from 'moment';
import {NextImg} from '@/utils/nextImg';

export const CompetitorsDetail = observer(() => {
  const {contentOptimizer: {
    currentPage: {
      setShowCompetitorTermsTableDetail,
      competitorSchemaObject,
      competitorTitle,
      competitorUrl,
      competitorSchemaGraphIdx,
    }}} = useStore('');

  const formats = [
    moment.ISO_8601,
    'MM/DD/YYYY  :)  HH*mm*ss',
  ];

  // const addDefaultSrc = e => {
  //   e.target.src = '/img/world-wide-web.svg';
  // };

  const renderSchemaData = dataObj => {
    return <>
      <div style={{display: 'flex', marginBottom: 20, marginTop: 6}}>
        <LargeLine />
        <div style={{width: '100%', overflow: 'hidden'}}>
          {dataObj && Object?.entries(dataObj)?.map((item, index) => {
            const mainLebel = item[0];
            const mainValue = item[1];
            return <div key={`${mainValue}_id_${index}`}>
              <SchemaLabel>{mainLebel && mainLebel != '0' ? mainLebel == 'type' ? `@${mainLebel}` : mainLebel : ''}</SchemaLabel>
              {typeof mainValue !== 'object' ? <SchemaValue>{typeof mainValue == 'boolean' ? `${mainValue ? 'Yes' : 'No'}` : (
                urlValidationRegex2?.test(String(mainValue)) ? <URL href={`${mainValue}`} target='_blank' rel='noopener noreferrer'>{String(mainValue)}</URL> : (
                  moment(mainValue, formats, true)?.isValid() || mainLebel?.includes('date') ? moment(mainValue)?.utc()?.format('DD MMM YYYY') : `${mainValue}`
                )
              )}</SchemaValue> :
                renderSchemaData(mainValue)}
            </div>;
          })}
        </div>
      </div>
    </>;
  };

  return <>
    <BackArrowContainer onClick={
      () => setShowCompetitorTermsTableDetail(false)
    }>
      <FontAwesomeIcon icon={faArrowLeft} style={{marginRight: 24}}/>
      Back to list of competitors
    </BackArrowContainer>
    <SchemaContainer>
      <SchemaHeader>
        <span style={{cursor: 'pointer', marginRight: '10px'}}>
          <NextImg style={{height: '20px', width: '20px'}}
          // onError={e => addDefaultSrc(e)}
            src={`https://www.google.com/s2/favicons?sz=16&domain_url=${competitorUrl}`} />
        </span>
        <SchemaPageTitle>
          <div>{competitorTitle}</div>
          <a style={{width: '240px', overflow: 'hidden', textOverflow: 'ellipsis'}} href={competitorUrl} target='_blank' rel='noreferrer'>{competitorUrl}</a>
        </SchemaPageTitle>
      </SchemaHeader>
      <div style={{margin: '20px 30px'}}>
        <SchemaLabel>@context</SchemaLabel>
        <SchemaValue>{competitorSchemaObject?.context ?? '-'}</SchemaValue>
        <SchemaLabel>@graph</SchemaLabel>
        {renderSchemaData(competitorSchemaObject?.graph ? competitorSchemaObject?.graph[competitorSchemaGraphIdx] : competitorSchemaObject)}
      </div>
    </SchemaContainer>
  </>;
});

const BackArrowContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-left: 33px;
  margin-top: 37px;
  width: max-content;
`;

const SchemaContainer = styled.div`
  width: 95%;
  margin-left: 30px;
  margin-top: 27px;
  min-height: 630px;
  background-color: white;
  border-radius: 14px;
  border: 1px solid #E8E8E8;
  box-shadow: 1px -2px 20px 0px rgba(0, 0, 0, 0.06);
`;

const SchemaLabel = styled.div`
  font-weight: 300;
  font-size: 14px;
  line-height: 22px;
  color: #4E5156;
  margin-top: 8px;
`;

const SchemaValue = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #121212;
`;

const LargeLine = styled.div`
  width: 2px;
  height: auto;
  background: #E8E8E8;
  border-radius: 6px;
  margin-right: 9px;
`;

const URL = styled.a`
  color: #2D6CCA;
  cursor: pointer;
  flex-wrap: nowrap;
  white-space: pre-wrap;
  word-break: break-word;
`;

const SchemaHeader = styled.div`
  display: flex;
  align-items: center;
  margin-left: 30px;
  margin-top: 20px;
`;

const SchemaPageTitle = styled.div`

`;
